import Vue from "vue";
import {
  Icon,
  Tab,
  Tabs,
  List,
  Cell,
  Button,
  Popup,
  Field,
  Dialog,
  Toast,
  Swipe,
  SwipeItem,
  Area,
  NavBar,
  CellGroup,
  Image,
  Sticky,
  Form,
  Picker,
  Checkbox,
  CheckboxGroup,
  Loading,
  Cascader,
  Calendar,
  Search,
  Popover,
  PullRefresh,
  Overlay,
  RadioGroup,
  Radio,
  Badge,
  Lazyload,
  Divider,
  ImagePreview,
  Collapse,
  CollapseItem,
  Uploader,
  DatetimePicker,
  Tabbar,
  TabbarItem,
  Progress,
  Rate,
  Circle,
  CountDown,
  ActionSheet,
  IndexBar,
  IndexAnchor,
} from "vant";
import "vant/lib/index.css";
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(List);
Vue.use(Cell);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(Search);
Vue.use(SwipeItem);
Vue.use(Area);
Vue.use(NavBar);
Vue.use(CellGroup);
Vue.use(Image);
Vue.use(Sticky);
Vue.use(Circle);
Vue.use(Form);
Vue.use(Picker);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox); // 复选框
Vue.use(CheckboxGroup);
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Cascader);
Vue.use(Calendar);
Vue.use(Badge);
Vue.use(Lazyload);
Vue.use(Divider);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(ImagePreview);
Vue.use(Popover);
Vue.use(Uploader);
Vue.use(Search);
Vue.use(DatetimePicker);
Vue.use(PullRefresh);
Vue.use(Progress);
Vue.use(Rate);
Vue.use(CountDown);
Vue.use(ActionSheet);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
